"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductListFilterItemRange = void 0;
const ProductListFilterItem_1 = require("./ProductListFilterItem");
class ProductListFilterItemRange extends ProductListFilterItem_1.ProductListFilterItem {
    constructor(filterItemData) {
        super(filterItemData);
        this.range = filterItemData.values
            .map((value) => {
            return parseFloat(value.id);
        })
            .sort();
        this._value = this.getValueFromResult(filterItemData);
    }
    get min() {
        return Math.min(...this.range);
    }
    get max() {
        return Math.max(...this.range);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = {
            min: Math.max(value.min, this.min),
            max: Math.min(value.max, this.max),
        };
    }
    get paramValue() {
        const value = this.value;
        if (value.min !== this.min || value.max !== this.max) {
            return `${value.min !== this.min ? value.min : ""}-${value.max !== this.max ? value.max : ""}`;
        }
        return "";
    }
    clear() {
        this._value = {
            min: this.min,
            max: this.max,
        };
    }
    getValueFromResult(filterItem) {
        return {
            min: Number(filterItem.minValue) || this.min,
            max: Number(filterItem.maxValue) || this.max,
        };
    }
    applyFilterItemResult(filterItem) {
        this._value = this.getValueFromResult(filterItem);
    }
}
exports.ProductListFilterItemRange = ProductListFilterItemRange;
